export default { title: 'application_settings', components: [] };
